import { createSelector } from '@reduxjs/toolkit';
import { State } from './types';
import { RootState } from '../root-reducer';
import { SaveCommunicationError } from 'types';

const rootSelector = (state: RootState): State => state.SendCommunication;

export const isBulkCommunicationSelector = createSelector(rootSelector, (state) => state?.isBulkCommunication);

export const initializeCommunicationstatusSelector = createSelector(
  rootSelector,
  (state) => state.initializeCommunication.status
);
export const initializeCommunicationerrorSelector = createSelector(
  rootSelector,
  (state) => state.initializeCommunication.error
);

export const initializeCommunicationDataSelector = createSelector(
  rootSelector,
  (state) => state.initializeCommunication.data
);
export const selectedServicesSelector = createSelector(
  initializeCommunicationDataSelector,
  (data) => data?.response?.services
);
export const selectedServiceTypeSelector = createSelector(
  initializeCommunicationDataSelector,
  (data) => data?.response?.servicesType
);
export const selectedServiceTypeIDSelector = createSelector(
  initializeCommunicationDataSelector,
  (data) => data?.response?.servicesTypeID
);
export const stationsConcernedSelector = createSelector(initializeCommunicationDataSelector, (data) => {
  const allStations: Array<{ shortCode: string; uicStation: string }> = [];
  data?.response?.stations.map(({ stationShortCode, stationUicCode }) => {
    allStations.push({
      shortCode: stationShortCode,
      uicStation: stationUicCode,
    });
  });
  return allStations;
});
export const equipementCarriagesSelector = createSelector(
  initializeCommunicationDataSelector,
  (data) => data?.response?.equipementCarriages
);
export const maxDaysBeforeDeferredSendingSelector = createSelector(
  initializeCommunicationDataSelector,
  (data) => data?.response?.maxDaysBeforeDeferredSending
);

export const saveCommunicationHasErrorSelector = createSelector(
  rootSelector,
  (state) => !!state.saveCommunication.error
);
export const saveCommunicationStatusSelector = createSelector(rootSelector, (state) => state.saveCommunication.status);
export const saveCommunicationDataSelector = createSelector(rootSelector, (state) => state.saveCommunication.data);
export const saveCommunicationErrorSelector = createSelector(
  saveCommunicationDataSelector,
  saveCommunicationHasErrorSelector,
  (saveCommunicationdata, saveCommunicationhasError) => {
    let errorMessage: SaveCommunicationError = {
      hasError: false,
      message: undefined,
    };

    if (saveCommunicationhasError) {
      if (saveCommunicationdata?.message) {
        errorMessage = {
          hasError: true,
          message: saveCommunicationdata?.message,
        };
      } else {
        errorMessage = {
          hasError: true,
          message: undefined,
        };
      }
    }
    return errorMessage;
  }
);

export const firstStepFormValuesSelector = createSelector(rootSelector, (state) => state.firstStepformValues);
export const secondStepFormValuesSelector = createSelector(rootSelector, (state) => state.secondStepformValues);

export default {
  initializeCommunicationstatusSelector,
  initializeCommunicationerrorSelector,
  initializeCommunicationDataSelector,

  selectedServicesSelector,
  stationsConcernedSelector,
  selectedServiceTypeSelector,
  selectedServiceTypeIDSelector,

  firstStepFormValuesSelector,
  secondStepFormValuesSelector,

  saveCommunicationErrorSelector,
};
